import { DataTableV2DataRow, DataTableV2DataSchema, DataTableV2UploadFilesAction } from './types'

function readNamespaceValue(value: unknown): string {
  return typeof value === 'string' ? value.trim() : ''
}

export function resolveUploadNamespace(
  action: DataTableV2UploadFilesAction,
  dataSchema: DataTableV2DataSchema,
  localData: DataTableV2DataRow[],
): string {
  const namespaceParam = action.parameterMappings?.namespace
  if (!namespaceParam) return ''

  const schemaValue = readNamespaceValue((dataSchema as Record<string, unknown>)[namespaceParam])
  if (schemaValue) return schemaValue

  for (const row of localData) {
    const rowValue = readNamespaceValue(row[namespaceParam])
    if (rowValue) return rowValue
  }

  return ''
}
